import { put } from "redux-saga/effects";
import { GraphQLServerError } from "~/common/graphql/GraphQLServerError";
import { HandlingConfiguration, prepareApiErrorResponseOrLogError } from "../../Actions/errorActions";

export function* handleApiError(e: Partial<JQuery.jqXHR> | GraphQLServerError, configuration?: HandlingConfiguration) {
    const errorAction = prepareApiErrorResponseOrLogError(e, configuration) as any;
    if (errorAction) {
        yield put(errorAction);
    }
}
